export function initLangSwitch() {
  document.querySelectorAll('.js-langSwitch').forEach(el => {
    const trigger = el.querySelector('.langSwitch__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', e => {
      e.stopPropagation();
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      el.classList.toggle('is-open', !expanded);
    });

    document.addEventListener('click', () => {
      trigger.setAttribute('aria-expanded', 'false');
      el.classList.remove('is-open');
    });

    el.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        el.classList.remove('is-open');
        trigger.focus();
      }
    });
  });
}